import PropTypes from "prop-types"
import React from "react"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const OriginalPrice = ({ label, amount, currency = "USD" }) => {
  return (
    <div className="flex items-center justify-between text-gray-600">
      <span>{label}</span>
      <span className="line-through">
        {formatCurrencyFromMinorUnits({ amount, currency })}
      </span>
    </div>
  )
}

OriginalPrice.propTypes = {
  label: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string,
}

export default OriginalPrice
